import { Space, Spin } from 'antd';
import { memo, useContext } from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import { excludeRoute, session } from '../helpers/helpers';
import mainRoutes from '../helpers/mainRoutes';
import { AuthContext } from './AuthContext';

const routePermissionMap = {
  'requests': 'requests',
  'create-request': 'requests',
  'edit-request': 'requests',
  'requests:detail': 'requests',
  'accounts': 'accounts',
  'contacts': 'marketing',
  'contacts:create': 'marketing',
  'contacts:edit': 'marketing',
  'commodity-circulation': 'commodity',
};

const isDenied = (value) => value === false || value === 'false' || value === 0 || value === '0';

const resolvePermissionKey = (pathname) => {
  const [first, second] = pathname.replace(/^\//, '').split('/');

  if (!first) {
    return null;
  }

  if (first === 'requests' && second) {
    return routePermissionMap['requests:detail'];
  }

  if (first === 'contacts') {
    if (second === 'create') {
      return routePermissionMap['contacts:create'];
    }
    if (second === 'edit' || second === 'edit-request') {
      return routePermissionMap['contacts:edit'];
    }
  }

  return routePermissionMap[first] || null;
};

const Guard = ({ history, children }) => {
  const token = session.get('token');
  const { loading, user, currentContactStore } = useContext(AuthContext);

  const mainRoutesPatnames = mainRoutes.some(({ path }) => {
    const [currentPath] = path.replace(/^\//, '').split('/');
    const [mathRoute] = history.location.pathname.replace(/^\//, '').split('/');

    if (!user) return currentPath === mathRoute;

    const permissionKey = resolvePermissionKey(history.location.pathname);
    if (permissionKey && isDenied(currentContactStore?.[permissionKey])) {
      return false;
    }

    if (currentPath === 'commodity-circulation' && isDenied(currentContactStore?.commodity)) {
      return false;
    }

    return currentPath === mathRoute;
  });

  if (loading && token) {
    return (
      <Space className="loading" size="middle">
        <Spin size="large" />
      </Space>
    );
  }

  if (mainRoutesPatnames) {
    if (excludeRoute.includes(history.location.pathname) || token) {
      const permissionKey = resolvePermissionKey(history.location.pathname);
      if (permissionKey && isDenied(currentContactStore?.[permissionKey])) {
        return <Redirect to="/" />;
      }
      return children;
    }
  }

  return token ? <Redirect to="/" /> : <Redirect to="/signin" />;
};

export default withRouter(memo(Guard));
